import { gql } from "@apollo/client";

export const LIST_CURRENCY = gql`
  query listCurrency($input: ListCurrencyInput) {
    listCurrency(input: $input) {
      code
      name
      symbolNative
    }
  }
`;

export const LIST_APP = gql`
  query listApp($input: ListAppInput!) {
    listApp(input: $input) {
      page
      pageSize
      totalData
      totalPages
      apps {
        _id
        appLogo
        appName
        appDescription
        isPushedToMP
        category {
          _id
          categoryName
        }
        createdBy {
          sub
          name
          profilePicture
        }
        currentAction {
          action
        }
        permissions {
          allUsers
          allAdmins
          specificUsers {
            sub
            name
            _id
            profilePicture
          }
          specificGroups {
            _id
            groupName
          }
        }
        currentStatus
        createdAt
      }
    }
  }
`;

export const CREATE_APP = gql`
  mutation createApp($input: CreateAppInput!) {
    createApp(input: $input) {
      _id
      appName
      appDescription
      category {
        _id
      }
      createdBy {
        sub
      }
      currentAction {
        action
      }
      currentStatus
      createdAt
    }
  }
`;

export const UPDATE_APP = gql`
  mutation updateApp($input: UpdateAppInput!) {
    updateApp(input: $input) {
      _id
      appDescription
      appLogo
      appName
      category {
        _id
      }
      favicon
      permissions {
        allUsers
        allAdmins
        specificUsers {
          sub
          name
          _id
          profilePicture
        }
        specificGroups {
          _id
          groupName
        }
      }
      fontColor
      secondaryColor
      primaryColor
      navigation {
        homePageMenu
        menus {
          _id
          createdBy
          title
          addSeperatorBelow
          action
          params {
            formId
            templateId
            link
          }
          callAnApi {
            customToken
            endpoint
            method
            payload
            queryString
            sendToken
          }
          permissions {
            allUsers
            allAdmins
            specificUsers {
              sub
              name
              _id
              profilePicture
            }
            specificGroups {
              _id
              groupName
            }
          }
          children {
            _id
            createdBy
            title
            addSeperatorBelow
            action
            params {
              formId
              templateId
              link
            }
            callAnApi {
              customToken
              endpoint
              method
              payload
              queryString
              sendToken
            }
            permissions {
              allUsers
              allAdmins
              specificUsers {
                sub
                name
                _id
                profilePicture
              }
              specificGroups {
                _id
                groupName
              }
            }
            children {
              _id
              createdBy
              title
              addSeperatorBelow
              action
              params {
                formId
                templateId
                link
              }
              callAnApi {
                customToken
                endpoint
                method
                payload
                queryString
                sendToken
              }
              permissions {
                allUsers
                allAdmins
                specificUsers {
                  sub
                  name
                  _id
                  profilePicture
                }
                specificGroups {
                  _id
                  groupName
                }
              }
              children {
                _id
                createdBy
                action
                title
                addSeperatorBelow
                params {
                  formId
                  templateId
                  link
                }
                callAnApi {
                  endpoint
                  method
                  payload
                  queryString
                  sendToken
                }
                permissions {
                  allUsers
                  allAdmins
                  specificUsers {
                    sub
                    name
                    _id
                    profilePicture
                  }
                  specificGroups {
                    _id
                    groupName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const DELETE_APP = gql`
  mutation DeleteApp($input: DeleteAppInput) {
    deleteApp(input: $input) {
      _id
    }
  }
`;

export const CLONE_APP = gql`
  mutation CloneApp($input: CloneAppInput!) {
    cloneApp(input: $input) {
      _id
      appName
      appDescription
      category {
        _id
        categoryName
      }
      createdBy {
        sub
        name
        profilePicture
      }
      currentAction {
        action
      }
      currentStatus
      createdAt
    }
  }
`;

export const UPDATE_APP_STATUS = gql`
  mutation UpdateAppStatus($input: UpdateAppStatusInput!) {
    updateAppStatus(input: $input) {
      _id
      appName
      appDescription
      category {
        _id
      }
      createdBy {
        sub
        name
      }
      currentAction {
        action
      }
      currentStatus
      createdAt
    }
  }
`;

export const UPDATE_FORM_STATUS = gql`
  mutation UpdateFormStatus($input: updateFormStatusInput!) {
    updateFormStatus(input: $input) {
      _id
      formName
      formDescription
      createdAt
      type
      createdBy {
        sub
        name
      }
      currentAction {
        action
      }
      currentStatus
    }
  }
`;

export const LIST_CATEGORY_NAME_AND_ID = gql`
  query listCategory {
    listCategory {
      categoryName
      _id
    }
  }
`;

export const LIST_CATEGORIES = gql`
  query listCategory {
    listCategory {
      _id
      categoryName
      categoryDescription
      createdAt
      noOfApps
      createdBy {
        sub
        name
      }
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation createCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      _id
      categoryName
      categoryDescription
      createdAt
      createdBy {
        sub
        name
      }
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      _id
      categoryName
      categoryDescription
      createdAt
      createdBy {
        sub
        name
      }
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($input: DeleteCategoryInput!) {
    deleteCategory(input: $input) {
      _id
    }
  }
`;

export const LIST_COUNTRY_TIME_ZONE = gql`
  query TimeZone($input: ListCountryAndTimeZoneInput!) {
    listCountryAndTimeZone(input: $input) {
      timeZone {
        WindowsTimeZones {
          Id
          Name
        }
      }
      _id
      code
      dial_code
      flag
      name
    }
  }
`;

export const LIST_COUNTRY_DIAL_CODES = gql`
  query listDialCodes($input: ListCountryAndTimeZoneInput!) {
    listCountryAndTimeZone(input: $input) {
      _id
      dial_code
      flag
      name
    }
  }
`;

export const GET_PROFILE = gql`
  query GetProfileDetails {
    getProfileDetails {
      _id
      sub
      country
      timeZone
      name
      mobile
      email
      userType
      active_flag
      dialCode
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      _id
      sub
      country
      timeZone
      name
      mobile
      email
      userType
      active_flag
      dialCode
    }
  }
`;

export const LIST_ELEMENT = gql`
  query ListElement($input: listElementInput!) {
    listElement(input: $input) {
      _id
      title
      type
      visible
    }
  }
`;

export const LIST_FORM = gql`
  query ListForm($input: ListFormInput!) {
    listForm(input: $input) {
      _id
      formName
      formDescription
      createdAt
      type
      createdBy {
        sub
        name
      }
      currentAction {
        action
      }
      formData {
        _id
        pages {
          id
          title
        }
      }
      currentStatus
    }
  }
`;

export const LIST_FORM_FOR_MANAGE_FORM = gql`
  query ListForm($input: ListFormInput!) {
    listForm(input: $input) {
      _id
      formName
      formDescription
      createdAt
      type
      createdBy {
        sub
        name
      }
      currentAction {
        action
      }
      currentStatus
    }
  }
`;

export const LIST_FORM_FOR_MENU = gql`
  query ListForm($input: ListFormInput!) {
    listForm(input: $input) {
      formName
      _id
      type
      responseTemplates {
        _id
        templateName
        formId
      }
    }
  }
`;

export const GET_MENU = gql`
  query ListMenu($input: ListMenuInput!) {
    listMenu(input: $input) {
      parentTree
      title
      _id
      params {
        formId
        link
        templateId
      }
      action
      parentMenuId
      callAnApi {
        endpoint
        method
        payload
        queryString
        sendToken
      }
      children {
        _id
        parentTree
        title
        params {
          formId
          link
          templateId
        }
        action
        parentMenuId
        callAnApi {
          endpoint
          method
          payload
          queryString
          sendToken
        }
        children {
          _id
          parentTree
          title
          params {
            formId
            link
            templateId
          }
          permissions {
            allUsers
            allAdmins
            specificUsers {
              sub
              name
              _id
            }
            specificGroups {
              _id
              groupName
            }
          }
          action
          parentMenuId
          callAnApi {
            endpoint
            method
            payload
            queryString
            sendToken
          }
          children {
            _id
            parentTree
            title
            params {
              formId
              link
              templateId
            }
            permissions {
              allUsers
              allAdmins
              specificUsers {
                sub
                name
                _id
              }
              specificGroups {
                _id
                groupName
              }
            }
            action
            parentMenuId
            callAnApi {
              endpoint
              method
              payload
              queryString
              sendToken
            }
          }
        }
        permissions {
          allUsers
          allAdmins
          specificUsers {
            sub
            name
            _id
          }
          specificGroups {
            _id
            groupName
          }
        }
      }
      permissions {
        allUsers
        allAdmins
        specificUsers {
          sub
          name
          _id
        }
        specificGroups {
          _id
          groupName
        }
      }
      callAnApi {
        endpoint
        method
        payload
        queryString
        sendToken
      }
    }
  }
`;

export const LIST_PUBLISHED_APPS = gql`
  query ListApp($input: ListAppInput!) {
    listApp(input: $input) {
      apps {
        appName
        appDescription
        createdAt
        primaryColor
        fontColor
        appLogo
        _id
        category {
          _id
          categoryName
        }
        navigation {
          homePageMenuData {
            action
            _id
            params {
              formId
              templateId
              dashboardId
            }
            callAnApi {
              endpoint
              method
              payload
              queryString
              sendToken
              customToken
              sendCustomToken
              sendResponse
            }
          }
        }
      }
    }
  }
`;

export const CREATE_MENU = gql`
  mutation CreateMenu($input: CreateMenuInput!) {
    createMenu(input: $input) {
      _id
    }
  }
`;

export const UPDATE_MENU = gql`
  mutation UpdateMenu($input: UpdateMenuInput!) {
    updateMenu(input: $input) {
      _id
    }
  }
`;

export const DELETE_MENU = gql`
  mutation DeleteMenu($input: DeleteMenuInput!) {
    deleteMenu(input: $input) {
      _id
    }
  }
`;

export const CREATE_FORM = gql`
  mutation createForm($input: CreateFormInput!) {
    createForm(input: $input) {
      _id
      formName
      formDescription
      type
      currentAction {
        action
      }
      currentStatus
      createdAt
      createdBy {
        sub
        name
      }
    }
  }
`;

export const DELETE_FORM = gql`
  mutation DeleteForm($input: DeleteFormInput!) {
    deleteForm(input: $input) {
      _id
    }
  }
`;

export const CLONE_FORM = gql`
  mutation CloneForm($input: CloneFormInput!) {
    cloneForm(input: $input) {
      _id
      formName
      formDescription
      createdAt
      type
      createdBy {
        sub
        name
      }
      currentAction {
        action
      }
      currentStatus
    }
  }
`;

export const GET_FORM_META_DATA = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      currentAction {
        action
      }
      formName
      formDescription
      currentStatus
      type
    }
  }
`;

export const GET_FORM_TYPE = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      type
    }
  }
`;

export const GET_FORM_PAGES = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      formData {
        _id
        pages {
          id
          title
        }
      }
    }
  }
`;

export const GET_FORM_PAGES_AND_QUESTIONS = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      formData {
        _id
        pages {
          id
          title
          questions {
            id
            content
            type
            title
          }
        }
      }
    }
  }
`;

export const GET_FORM = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      currentAction {
        action
      }
      company {
        _id
      }
      type
      currentStatus
      showQuestionNo
      coverImage
      removeBranding
      submitButtonText
      resetFormAfterSubmit
      formData {
        _id
        fieldRules {
          id
          immutable
          name
          pageId
          questionId
          enabled
          action {
            type
            value
            validationType
            validationErrorMessage
            valueType
          }
          filter {
            fieldsets {
              questionId
              questionType
              relationalOperator
              secondaryRelationalOperator
              answer
            }
            logicalOperator
          }
        }
        pages {
          id
          title
          description
          allowSubmit
          nextButtonText
          questions {
            id
            content
            type
            title
          }
        }
      }
      formName
      formDescription
    }
  }
`;

export const GET_FORM_LIVE = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      company {
        _id
      }
      showQuestionNo
      removeBranding
      coverImage
      submitButtonText
      enableCaptcha
      resetFormAfterSubmit
      type
      formData {
        _id
        fieldRules {
          id
          immutable
          name
          pageId
          questionId
          enabled
          action {
            type
            value
            validationType
            validationErrorMessage
            valueType
          }
          filter {
            fieldsets {
              questionId
              questionType
              relationalOperator
              secondaryRelationalOperator
              answer
            }
            logicalOperator
          }
        }
        pages {
          id
          title
          description
          allowSubmit
          nextButtonText
          questions {
            id
            content
            type
            title
          }
        }
      }
      formName
      formDescription
    }
  }
`;

export const CREATE_RESPONSE_TEMPLATE = gql`
  mutation CreateResponseTemplate($input: CreateResponseTemplateInput!) {
    createResponseTemplate(input: $input) {
      _id
      templateName
      templateDescription
      createdBy {
        sub
        name
      }
      showPgResponses
      isParent
      aliasResponseTemplateId
      allowDataFilter
      showCreatedAtColumn
      showCreatedByColumn
      allowCreatingNewRecord
      allowDownloadAsExcel
      createdAt
      format {
        formatType
        questionId
      }
      templateSort {
        order
        questionId
        questionType
      }
      templateFields {
        alias
        isSingleField
        questionIds
        enabled
      }
      templateFilter {
        fieldsets {
          answer
          questionId
          questionType
          relationalOperator
          secondaryRelationalOperator
        }
        logicalOperator
      }
      columnCalc {
        operator
        questionId
        showPerPage
        prefix
        postfix
      }
      rules {
        _id
        ruleName
      }
      recordsPerPage
      systemActions
    }
  }
`;

export const UPDATE_RESPONSE_TEMPLATE = gql`
  mutation UpdateResponseTemplate($input: UpdateResponseTemplateInput!) {
    updateResponseTemplate(input: $input) {
      _id
      templateName
      createdBy {
        sub
        name
      }
      isParent
      showPgResponses
      aliasResponseTemplateId
      showCreatedAtColumn
      showCreatedByColumn
      showUpdatedAtColumn
      searchableFields
      allowCreatingNewRecord
      allowDataFilter
      allowDownloadAsExcel
      createdAt
      templateSort {
        order
        questionId
        questionType
      }
      format {
        formatType
        questionId
      }
      templateFields {
        alias
        isSingleField
        questionIds
        enabled
      }
      templateFilter {
        fieldsets {
          answer
          questionId
          questionType
          relationalOperator
          secondaryRelationalOperator
        }
        logicalOperator
      }
      primaryFilter {
        questionId
        dateViewType
        viewType
        order
        sortBy
      }
      columnCalc {
        operator
        questionId
        showPerPage
        prefix
        postfix
      }
      arrangement {
        type
        groupBy
        header
        showWeekends
      }
      recordsPerPage
      systemActions
      rules {
        _id
        ruleName
      }
    }
  }
`;

export const DELETE_RESPONSE_TEMPLATE = gql`
  mutation DeleteResponseTemplate($input: DeleteResponseTemplateInput!) {
    deleteResponseTemplate(input: $input) {
      _id
    }
  }
`;

export const GET_RESPONSE_TEMPLATE = gql`
  query GetResponseTemplate($input: GetResponseTemplateInput!) {
    getResponseTemplate(input: $input) {
      _id
      templateName
      createdBy {
        sub
        name
      }
      showPgResponses
      aliasResponseTemplateId
      allowDataFilter
      isParent
      createdAt
      searchableFields
      showUpdatedAtColumn
      showCreatedAtColumn
      showCreatedByColumn
      allowDownloadAsExcel
      allowCreatingNewRecord
      format {
        formatType
        questionId
      }
      templateSort {
        order
        questionId
        questionType
      }
      templateFields {
        alias
        isSingleField
        questionIds
        enabled
      }
      templateFilter {
        fieldsets {
          answer
          questionId
          questionType
          relationalOperator
          secondaryRelationalOperator
        }
        logicalOperator
      }
      primaryFilter {
        questionId
        dateViewType
        viewType
        order
        sortBy
        defaultDateViewType
      }
      recordsPerPage
      systemActions
      rules {
        _id
        ruleName
        ruleTrigger
      }
      arrangement {
        type
        groupBy
        header
        showWeekends
        mobileHeader
      }
      columnCalc {
        operator
        questionId
        showPerPage
        prefix
        postfix
      }
    }
  }
`;

export const GET_RESPONSE_TEMPLATE_FIELDS = gql`
  query GetResponseTemplate($input: GetResponseTemplateInput!) {
    getResponseTemplate(input: $input) {
      _id
      searchableFields
      templateFields {
        alias
        isSingleField
        questionIds
        enabled
      }
    }
  }
`;

export const GET_RESPONSE_TEMPLATE_FOR_RESPONSES = gql`
  query GetResponseTemplate($input: GetResponseTemplateInput!) {
    getResponseTemplate(input: $input) {
      _id
      templateName
      form {
        type
      }
      format {
        formatType
        questionId
      }
      templateFields {
        alias
        isSingleField
        questionIds
      }
      primaryFilter {
        questionId
        dateViewType
        viewType
        defaultDateViewType
      }
      showActionColumn
      allowDataFilter
      showCreatedAtColumn
      showCreatedByColumn
      showUpdatedAtColumn
      recordsPerPage
      searchableFields
      allowDownloadAsExcel
      allowCreatingNewRecord
      arrangement {
        type
        groupBy
        header
        showWeekends
        subTitle
        mobileHeader
      }
      columnCalc {
        operator
        questionId
        prefix
        postfix
      }
    }
  }
`;

export const LIST_RESPONSES = gql`
  query ListResponse($input: ListResponseInput!) {
    listResponse(input: $input) {
      page
      pageSize
      totalPages
      totalData
      messageMetaData
      responses {
        _id
        responseData
        systemActions
        rules {
          responseTemplateId
          _id
          ruleName
          useAsBulk
          ruleTrigger
          questionId
        }
        createdAt
        createdBy {
          sub
          name
          profilePicture
        }
        updatedAt
      }
      calendarResponseMetaData {
        responseIds
        value
      }
      columnCalc
    }
  }
`;

export const LIST_RESPONSES_FOR_CHILD_FORM = gql`
  query ListResponse($input: ListResponseInput!) {
    listResponse(input: $input) {
      page
      pageSize
      totalPages
      totalData
      responses {
        _id
        responseData
        createdAt
        createdBy {
          sub
          name
          profilePicture
        }
        updatedAt
      }
      columnCalc
    }
  }
`;

export const LIST_RESPONSES_FOR_DATA_MODEL = gql`
  query ListResponse($input: ListResponseInput!) {
    listResponse(input: $input) {
      page
      pageSize
      totalPages
      totalData
      responses {
        _id
        responseData
        createdAt
        createdBy {
          sub
          name
          profilePicture
        }
        updatedAt
      }
    }
  }
`;

export const CUSTOM_ACTIONS = gql`
  mutation CustomActions($input: CustomActionsInput!) {
    customActions(input: $input)
  }
`;

export const LIST_RESPONSE_TEMPLATE = gql`
  query ListResponseTemplate($input: ListResponseTemplateInput!) {
    listResponseTemplate(input: $input) {
      _id
      templateName
      isParent
      form {
        _id
      }
      templateFields {
        questionIds
      }
      createdBy {
        sub
        name
      }
      createdAt
      showPgResponses
    }
  }
`;

export const LIST_RESPONSE_TEMPLATE_FOR_RESPONSES = gql`
  query ListResponseTemplate($input: ListResponseTemplateInput!) {
    listResponseTemplate(input: $input) {
      _id
      templateName
    }
  }
`;

export const LIST_RESPONSE_TEMPLATES = gql`
  query ListResponseTemplate($input: ListResponseTemplateInput!) {
    listResponseTemplate(input: $input) {
      _id
      templateName
      templateFields {
        alias
        isSingleField
        questionIds
      }
    }
  }
`;

export const GET_FORM_QUESTIONS = gql`
  query GetQuestions($input: GetQuestionsInput!) {
    getQuestions(input: $input) {
      content
      id
      title
      type
      formId
    }
  }
`;

export const UPDATE_PROFILE_PICTURE = gql`
  mutation updateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      _id
      sub
      profilePicture
    }
  }
`;

export const GET_PROFILE_DETAILS = gql`
  query GetProfileDetails {
    getProfileDetails {
      _id
      sub
      profilePicture
      userType
      name
      email
      companyLogo
      companyName
      timeZone
    }
  }
`;

export const GET_USER_TIMEZONE = gql`
  query GetProfileDetails {
    getProfileDetails {
      _id
      sub
      timeZone
    }
  }
`;

export const CREATE_USER = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      sub
      user_status
      userType
      name
      email
      active_flag
      createdBy {
        sub
        name
        profilePicture
      }
      createdAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      sub
      userType
      user_status
      name
      email
      active_flag
      createdBy {
        sub
        name
        profilePicture
      }
      createdAt
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      _id
      sub
    }
  }
`;

export const LIST_USERS = gql`
  query listUsers($input: ListUserInput!) {
    listUsers(input: $input) {
      page
      pageSize
      totalPages
      totalData
      totalAdmins
      users {
        sub
        userType
        user_status
        name
        email
        active_flag
        groups {
          _id
          groupName
        }
        createdBy {
          name
          sub
          profilePicture
        }
        createdAt
      }
    }
  }
`;

export const LIST_USERS_META_DATA = gql`
  query Users($input: ListUserInput!) {
    listUsers(input: $input) {
      users {
        profilePicture
        name
        sub
        _id
      }
    }
  }
`;

export const CREATE_ENTITY = gql`
  mutation createEntity($input: CreateEntityInput!) {
    createEntity(input: $input) {
      entityName
      parentEntityId
    }
  }
`;

export const LIST_MANAGE_ENTITY = gql`
  query ListEntity($input: ListEntityInput) {
    listEntity(input: $input) {
      page
      pageSize
      totalData
      totalPages
      entities {
        _id
        hierarchyName
        entityName
        createdAt
        parentTree
        parentEntityId
        workingHours {
          weekData
        }
        createdBy {
          name
          sub
          profilePicture
        }
      }
    }
  }
`;

export const DELETE_ENTITY = gql`
  mutation deleteEntity($input: DeleteEntityInput!) {
    deleteEntity(input: $input) {
      _id
    }
  }
`;

export const UPDATE_ENTITY = gql`
  mutation updateEntity($input: UpdateEntityInput!) {
    updateEntity(input: $input) {
      _id
      entityName
      createdAt
      createdBy {
        name
        sub
        profilePicture
      }
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      _id
      companyName
      timeZone
      companyAddress
      companyLogo
      country
      workingHours {
        weekData
      }
    }
  }
`;

export const GET_COMPANY = gql`
  query GetCompany {
    getCompany {
      _id
      companyName
      companyLogo
      country
      timeZone
      companyAddress
    }
  }
`;

export const LIST_USER_META_DATA = gql`
  query ListUsers($input: ListUserInput!) {
    listUsers(input: $input) {
      users {
        sub
        name
        email
        userType
        groups {
          _id
        }
      }
    }
  }
`;

export const LIST_ENTITY = gql`
  query ListEntity($input: ListEntityInput) {
    listEntity(input: $input) {
      entities {
        _id
        entityName
      }
    }
  }
`;

export const GET_PERMISSIONS = gql`
  query GetPermission {
    getPermission {
      permissions
    }
  }
`;

export const LIST_MARKET_PLACE_CATEGROIES_AND_APPS = gql`
  query ListCategoryAndApp($input: listCategoryAndAppInput) {
    listCategoryAndApp(input: $input) {
      _id
      categoryName
      categoryDescription
      apps {
        _id
        appName
        createdAt
        appDetail {
          coverImage
        }
      }
      numberOfApps {
        approved
      }
    }
  }
`;

export const LIST_MARKET_PLACE_CATEGROIES = gql`
  query ListCategoryMP {
    listCategoryMP {
      _id
      categoryName
    }
  }
`;

export const FORM_DELTA = gql`
  mutation FormDelta($input: FormDeltaInput!) {
    formDelta(input: $input) {
      _id
    }
  }
`;

export const GET_APP_DETAILS = gql`
  query GetAppDetails($input: GetDetailsInput!) {
    getAppDetails(input: $input) {
      _id
      app {
        appDescription
        appName
        company {
          companyName
        }
        reviews {
          averageRatings
          starRatingMap
          totalRatings
          totalReviews
        }
      }
      coverImage
      createdAt
      details
      keywords
      isInstalled
      screenshots
      tags
      updatedAt
    }
  }
`;

export const CREATE_REVIEW = gql`
  mutation CreateReview($input: CreateReviewInput) {
    createReview(input: $input) {
      id
      comment
      createdBy {
        name
        profilePicture
      }
      company {
        companyName
      }
      rating
      createdAt
    }
  }
`;

export const LIST_REVIEW = gql`
  query ListReview($input: ListReviewsInput) {
    listReview(input: $input) {
      _id
      comment
      createdBy {
        name
        profilePicture
      }
      company {
        companyName
      }
      rating
      createdAt
    }
  }
`;

export const INSTALL_MARKET_PLACE = gql`
  mutation InstallMP($input: InstallMPInput!) {
    installMP(input: $input)
  }
`;

export const ADD_MARKET_PLACE = gql`
  mutation Mutation($input: AddMPInput!) {
    addMP(input: $input)
  }
`;

export const GET_FORM_DETAILS = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      formName
      formDescription
      coverImage
      company {
        _id
      }
      showQuestionNo
      compositeFields
      submitButtonText
      sendCopyOfResponse
      enableCaptcha
      resetFormAfterSubmit
      removeBranding
    }
  }
`;

export const UPDATE_FORM_DETAILS = gql`
  mutation UpdateForm($input: UpdateFormInput!) {
    updateForm(input: $input) {
      _id
      formName
      formDescription
      showQuestionNo
      coverImage
      submitButtonText
      compositeFields
      resetFormAfterSubmit
      sendCopyOfResponse
      enableCaptcha
      removeBranding
    }
  }
`;

export const DISTRIBUTE_FORM = gql`
  mutation DistributeForm($input: FormDistributionInput!) {
    distributeForm(input: $input) {
      url
      _id
    }
  }
`;

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      companyAddress
      companyLogo
      companyName
      country
      timeZone
      workingHours {
        weekData
      }
      _id
    }
  }
`;

export const GET_ACTION = gql`
  query GetAction {
    getAction {
      systemActions
    }
  }
`;

export const GET_RESPONSE = gql`
  query GetResponse($input: GetResponseInput!) {
    getResponse(input: $input) {
      responseData
    }
  }
`;

export const LIST_GROUP = gql`
  query ListGroup {
    listGroup {
      _id
      createdAt
      createdBy {
        name
        profilePicture
        sub
      }
      groupDescription
      groupName
      users {
        name
        profilePicture
        sub
      }
    }
  }
`;

export const LIST_GROUP_META_DATA = gql`
  query ListGroup {
    listGroup {
      _id
      groupName
    }
  }
`;

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      _id
      createdAt
      createdBy {
        name
        profilePicture
        sub
      }
      groupDescription
      groupName
      users {
        name
        profilePicture
        sub
      }
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      _id
      createdBy {
        name
        profilePicture
        sub
      }
      groupDescription
      groupName
      users {
        name
        profilePicture
        sub
      }
    }
  }
`;

export const DELETE_GROUP = gql`
  mutation DeleteGroup($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      _id
    }
  }
`;

export const CREATE_OTP = gql`
  mutation CreateOtp($input: CreateOtpInput!) {
    createOtp(input: $input) {
      _id
    }
  }
`;

export const VALIDATE_OTP = gql`
  mutation VerifyOtp($input: VerifyOtpInput!) {
    verifyOtp(input: $input) {
      isExpired
      isVerified
    }
  }
`;

export const VALIDATE_RULE = gql`
  mutation RuleValidatorExecutor($input: RuleValidatorExecutorInput!) {
    ruleValidatorExecutor(input: $input) {
      customActions {
        _id
        actionType
        params {
          appId
          formId
          pageId
          responseId
          templateId
          layoutId
          formType
        }
        actionMetaData {
          defaultValues
          staticValues
        }
      }
      backgroundRefresh
      isFormValid
    }
  }
`;

export const CREATE_CUSTOM_DEFINED_ACTION = gql`
  mutation CreateCustomDefinedAction($input: CreateCustomDefinedActionsInput!) {
    createCustomDefinedAction(input: $input) {
      _id
      actionName
      actionType
      enabled
      params {
        appId
        formId
        pageId
        templateId
        layoutId
      }
      actionMetaData {
        updatedFields {
          appId
          fieldsets {
            sourceQuestionId
            targetQuestionId
            sourceQuestionType
            targetQuestionType
            value
            valueType
          }
          formId
        }
        staticFields
        defaultFields {
          sourceQuestionId
          targetQuestionId
          sourceQuestionType
          targetQuestionType
          value
        }
        emailFields {
          emailIds {
            type
            value
            id
          }
          messageContent {
            body
            subject
          }
          senderEmailId
        }
        responseFilter {
          logicalOperator
          fieldsets {
            sourceQuestionId
            targetQuestionId
            sourceQuestionType
            targetQuestionType
            sourceInputType
            targetInputType
            relationalOperator
            secondaryRelationalOperator
            answerType
            answer
          }
        }
        hookFields {
          appId
          formId
          fieldsToCopy {
            sourceKey
            sourceQuestionId
            targetQuestionId
            value
          }
        }
        callAnApi {
          endpoint
          method
          payload
          queryString
          sendToken
        }
      }
    }
  }
`;

export const LIST_RULE = gql`
  query ListRule($input: ListRuleInput!) {
    listRule(input: $input) {
      _id
      ruleName
      createdAt
      createdBy {
        sub
        name
        profilePicture
      }
      ruleTrigger
    }
  }
`;

export const CREATE_RULE = gql`
  mutation CreateRule($input: CreateRuleInput!) {
    createRule(input: $input) {
      _id
      enabled
      ruleName
      successMessage
      failureMessage
      ruleTrigger
      pageId
      createdAt
      createdBy {
        sub
        name
        profilePicture
      }
      intervalDetails {
        frequency
        frequencyType
        repeatOnDays
        endType
        endDate
        occurrences
        repeatPerMonth
        repeatPerMonthString
        repeatOnMonths
        startDate
        repeatOnDay
      }
      ruleFilter {
        logicalOperator
        fieldsets {
          formId
          relationalOperator
          sourceQuestionId
          sourceQuestionType
          targetQuestionId
          targetQuestionType
          answer
          appId
          caseSensitive
          secondaryRelationalOperator
        }
      }
      useAsBulk
      ruleSatisfiedCustomActions {
        _id
        actionName
        actionType
      }
      ruleUnsatisfiedCustomActions {
        _id
        actionName
        actionType
      }
    }
  }
`;

export const CREATE_RULE_FOR_DATAVIEW = gql`
  mutation CreateRule($input: CreateRuleInput!) {
    createRule(input: $input) {
      _id
      ruleName
    }
  }
`;

export const DELETE_RULE = gql`
  mutation DeleteRule($input: DeleteRuleInput!) {
    deleteRule(input: $input) {
      _id
    }
  }
`;

export const GET_RULE = gql`
  query GetRule($input: GetRuleInput!) {
    getRule(input: $input) {
      _id
      enabled
      ruleName
      successMessage
      failureMessage
      ruleTrigger
      responseTemplateId
      questionId
      pageId
      intervalDetails {
        frequency
        frequencyType
        repeatOnDays
        endType
        endDate
        repeatOnDay
        occurrences
        repeatPerMonth
        repeatOnMonths
        startDate
        repeatPerMonthString
      }
      ruleFilter {
        logicalOperator
        fieldsets {
          formId
          relationalOperator
          sourceQuestionId
          sourceQuestionType
          targetQuestionId
          targetQuestionType
          answer
          appId
          caseSensitive
          secondaryRelationalOperator
        }
      }
      useAsBulk
      ruleSatisfiedCustomActions {
        _id
        actionName
        actionType
      }
      ruleUnsatisfiedCustomActions {
        _id
        actionName
        actionType
      }
    }
  }
`;

export const UPDATE_RULE = gql`
  mutation UpdateRule($input: UpdateRuleInput!) {
    updateRule(input: $input) {
      _id
      enabled
      ruleName
      successMessage
      failureMessage
      ruleTrigger
      pageId
      intervalDetails {
        frequency
        frequencyType
        repeatOnDays
        endType
        endDate
        occurrences
        repeatPerMonth
        repeatPerMonthString
        repeatOnMonths
        startDate
        repeatOnDay
      }
      ruleFilter {
        logicalOperator
        fieldsets {
          formId
          relationalOperator
          sourceQuestionId
          sourceQuestionType
          targetQuestionId
          targetQuestionType
          answer
          appId
          caseSensitive
          secondaryRelationalOperator
        }
      }
      useAsBulk
      ruleSatisfiedCustomActions {
        _id
        actionName
        actionType
      }
      ruleUnsatisfiedCustomActions {
        _id
        actionName
        actionType
      }
      createdAt
      createdBy {
        sub
        name
        profilePicture
      }
    }
  }
`;

export const GET_CUSTOM_DEFINED_ACTION = gql`
  query GetCustomDefinedAction($input: GetCustomDefinedActionsInput!) {
    getCustomDefinedAction(input: $input) {
      _id
      actionName
      actionType
      actionMetaData {
        updatedFields {
          appId
          fieldsets {
            sourceQuestionId
            targetQuestionId
            sourceQuestionType
            targetQuestionType
            value
            valueType
          }
          formId
        }
        responseFilter {
          logicalOperator
          fieldsets {
            targetQuestionType
            targetQuestionId
            sourceQuestionType
            sourceQuestionId
            secondaryRelationalOperator
            relationalOperator
            answerType
            answer
          }
        }
        staticFields
        defaultFields {
          sourceQuestionId
          targetQuestionId
          sourceQuestionType
          targetQuestionType
        }
        emailFields {
          emailIds {
            type
            value
            id
          }
          messageContent {
            body
            subject
          }
          senderEmailId
        }
        callAnApi {
          endpoint
          method
          payload
          queryString
          sendToken
        }
        hookFields {
          appId
          formId
          fieldsToCopy {
            sourceKey
            sourceQuestionId
            targetQuestionId
          }
        }
      }
      params {
        appId
        formId
        pageId
        templateId
        layoutId
      }
    }
  }
`;

export const UPDATE_CUSTOM_DEFINED_ACTION = gql`
  mutation UpdateCustomDefinedAction($input: UpdateCustomDefinedActionsInput!) {
    updateCustomDefinedAction(input: $input) {
      _id
      actionName
      actionType
      actionMetaData {
        updatedFields {
          appId
          fieldsets {
            sourceQuestionId
            targetQuestionId
            sourceQuestionType
            targetQuestionType
            value
            valueType
          }
          formId
        }
        staticFields
        defaultFields {
          sourceQuestionId
          targetQuestionId
          sourceQuestionType
          targetQuestionType
        }
        emailFields {
          emailIds {
            type
            value
            id
          }
          messageContent {
            body
            subject
          }
          senderEmailId
        }
        responseFilter {
          logicalOperator
          fieldsets {
            sourceQuestionId
            targetQuestionId
            sourceQuestionType
            targetQuestionType
            sourceInputType
            targetInputType
            relationalOperator
            secondaryRelationalOperator
            answerType
            answer
          }
        }
        hookFields {
          appId
          formId
          fieldsToCopy {
            sourceKey
            sourceQuestionId
            targetQuestionId
            value
          }
        }
        callAnApi {
          endpoint
          method
          payload
          queryString
          sendToken
        }
        hookFields {
          appId
          formId
          fieldsToCopy {
            sourceKey
            sourceQuestionId
            targetQuestionId
          }
        }
      }
      params {
        appId
        formId
        pageId
        templateId
        layoutId
      }
    }
  }
`;

export const DELETE_CUSTOM_DEFINED_ACTION = gql`
  mutation DeleteCustomDefinedAction($input: DeleteCustomDefinedActionsInput!) {
    deleteCustomDefinedAction(input: $input) {
      _id
      actionName
    }
  }
`;

export const EXPORT_RESPONSES = gql`
  mutation ExportData($input: ExportDataInput!) {
    exportData(input: $input) {
      url
    }
  }
`;

export const CLONE_RULE = gql`
  mutation CloneRule($input: CloneRuleInput!) {
    cloneRule(input: $input) {
      _id
      ruleName
      ruleTrigger
      createdAt
      createdBy {
        sub
        name
        profilePicture
      }
    }
  }
`;

export const CLONE_RESPONSE_TEMPLATE = gql`
  mutation CloneResponseTemplate($input: CloneResponseTemplateInput!) {
    cloneResponseTemplate(input: $input) {
      _id
      templateName
      isParent
      form {
        _id
      }
      templateFields {
        questionIds
      }
      createdBy {
        sub
        name
      }
      createdAt
    }
  }
`;

export const GET_APP = gql`
  query GetApp($input: GetAppInput!) {
    getApp(input: $input) {
      _id
      appDescription
      appLogo
      appName
      category {
        _id
      }
      favicon
      permissions {
        allUsers
        allAdmins
        specificUsers {
          sub
          name
          _id
          profilePicture
        }
        specificGroups {
          _id
          groupName
        }
      }
      fontColor
      secondaryColor
      primaryColor
      navigation {
        homePageMenu
        menus {
          _id
          createdBy
          title
          addSeperatorBelow
          parentTree
          parentMenuId
          action
          params {
            formId
            templateId
            link
            dashboardId
          }
          callAnApi {
            customToken
            endpoint
            method
            payload
            queryString
            sendToken
          }
          permissions {
            allUsers
            allAdmins
            specificUsers {
              sub
              name
              _id
              profilePicture
            }
            specificGroups {
              _id
              groupName
            }
          }
          children {
            _id
            createdBy
            title
            addSeperatorBelow
            parentTree
            parentMenuId
            action
            params {
              formId
              templateId
              link
            }
            callAnApi {
              customToken
              endpoint
              method
              payload
              queryString
              sendToken
            }
            permissions {
              allUsers
              allAdmins
              specificUsers {
                sub
                name
                _id
                profilePicture
              }
              specificGroups {
                _id
                groupName
              }
            }
            children {
              _id
              createdBy
              title
              addSeperatorBelow
              parentTree
              parentMenuId
              action
              params {
                formId
                templateId
                link
              }
              callAnApi {
                customToken
                endpoint
                method
                payload
                queryString
                sendToken
              }
              permissions {
                allUsers
                allAdmins
                specificUsers {
                  sub
                  name
                  _id
                  profilePicture
                }
                specificGroups {
                  _id
                  groupName
                }
              }
              children {
                _id
                createdBy
                action
                title
                addSeperatorBelow
                parentTree
                parentMenuId
                params {
                  formId
                  templateId
                  link
                }
                callAnApi {
                  endpoint
                  method
                  payload
                  queryString
                  sendToken
                }
                permissions {
                  allUsers
                  allAdmins
                  specificUsers {
                    sub
                    name
                    _id
                    profilePicture
                  }
                  specificGroups {
                    _id
                    groupName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_APP_CONFIG_FOR_FORM = gql`
  query GetApp($input: GetAppInput!) {
    getApp(input: $input) {
      _id
      appLogo
      appName
      favicon
      fontColor
      secondaryColor
      primaryColor
    }
  }
`;

export const GET_LAYOUT = gql`
  query GetLayout($input: GetLayoutInput!) {
    getLayout(input: $input) {
      _id
      layoutData
      layoutName
      responseTemplate {
        _id
        templateName
      }
    }
  }
`;

export const LIST_LAYOUTS = gql`
  query ListLayout($input: ListLayoutInput!) {
    listLayout(input: $input) {
      layoutData
      layoutName
      _id
      responseTemplate {
        _id
        templateName
      }
      createdAt
      createdBy {
        name
        sub
      }
    }
  }
`;

export const UPDATE_LAYOUT = gql`
  mutation UpdateLayout($input: UpdateLayoutInput!) {
    updateLayout(input: $input) {
      layoutData
      layoutName
      _id
    }
  }
`;

export const CREATE_LAYOUT = gql`
  mutation CreateLayout($input: CreateLayoutInput!) {
    createLayout(input: $input) {
      _id
      layoutName
      createdAt
      responseTemplate {
        _id
        templateName
      }
      createdBy {
        name
        sub
      }
    }
  }
`;

export const CLONE_LAYOUT = gql`
  mutation CloneLayout($input: CloneLayoutInput!) {
    cloneLayout(input: $input) {
      _id
      createdBy {
        sub
        name
      }
      layoutName
      createdAt
      layoutData
      responseTemplate {
        _id
        templateName
      }
    }
  }
`;

export const DELETE_LAYOUT = gql`
  mutation DeleteLayout($input: DeleteLayoutInput!) {
    deleteLayout(input: $input) {
      _id
    }
  }
`;

export const CLONE_CUSTOMDEFINED_ACTION = gql`
  mutation CloneCustomDefinedActions($input: CloneCustomDefinedActionsInput!) {
    cloneCustomDefinedActions(input: $input) {
      _id
      actionName
      actionType
    }
  }
`;

export const GET_AGGREGATION = gql`
  query GetAggregation($input: GetAggregationInput!) {
    getAggregation(input: $input)
  }
`;

export const LIST_RESPONSE_TEMPLATE_NAMES = gql`
  query ListResponseTemplate($input: ListResponseTemplateInput!) {
    listResponseTemplate(input: $input) {
      templateName
      _id
    }
  }
`;

export const GET_PRIMARY_FILTER = gql`
  query GetPrimaryFilterResponse($input: GetPrimaryFilterResponseInput!) {
    getPrimaryFilterResponse(input: $input) {
      start
      end
      allowLeftSwipe
      allowRightSwipe
      responses {
        id
        title
        answer
        isDefault
      }
      config {
        questionId
        questionType
        logicalOperator
        relationalOperator
        answer
      }
    }
  }
`;

export const BULK_ACTION = gql`
  mutation BulkActions($input: BulkActionsInput!) {
    bulkActions(input: $input) {
      message
    }
  }
`;

export const GROUP_BY_RESPONSE_UPDATE = gql`
  mutation GroupByResponseUpdate($input: GroupByResponseUpdateInput!) {
    groupByResponseUpdate(input: $input) {
      response {
        _id
        responseData
        createdAt
        updatedAt
      }
    }
  }
`;

export const LIST_SENDER_EMAILS = gql`
  query ListSenderEmail {
    listSenderEmail {
      emailId
      _id
      name
    }
  }
`;

export const CREATE_DASHBOARD = gql`
  mutation CreateDashboard($input: CreateDashboardInput!) {
    createDashboard(input: $input) {
      _id
      appId
      companyId
      createdBy {
        name
        sub
      }
      currentStatus
      createdAt
      updatedAt
      dashboardName
      dashboardDescription
    }
  }
`;

export const UPDATE_DASHBOARD = gql`
  mutation UpdateDashboard($input: UpdateDashboardInput!) {
    updateDashboard(input: $input) {
      _id
      appId
      companyId
      createdBy {
        name
        sub
      }
      dashboardName
      dashboardDescription
    }
  }
`;

export const LIST_DASHBOARDS_FOR_MANAGE_DASHBOARD = gql`
  query ListDashboard($input: ListDashboardInput!) {
    listDashboard(input: $input) {
      _id
      createdAt
      updatedAt
      appId
      dashboardName
      createdBy {
        name
        sub
      }
      dashboardDescription
      currentStatus
    }
  }
`;
export const DELETE_DASHBOARD = gql`
  mutation DeleteDashboard($input: DeleteDashboardInput!) {
    deleteDashboard(input: $input) {
      _id
    }
  }
`;
export const UPDATE_DASHBOARD_STATUS = gql`
  mutation UpdateDashboardStatus($input: UpdateDashboardStatusInput!) {
    updateDashboardStatus(input: $input) {
      dashboardName
      currentStatus
      _id
      createdBy {
        sub
        name
      }
    }
  }
`;

export const LIST_DASHBOARD_FOR_MENU = gql`
  query ListDashboard($input: ListDashboardInput!) {
    listDashboard(input: $input) {
      _id
      dashboardName
    }
  }
`;
export const GET_DASHBOARD = gql`
  query GetDashboard($input: GetDashboardInput!) {
    getDashboard(input: $input) {
      _id
      appId
      dashboardName
    }
  }
`;

export const LIST_WIDGET = gql`
  query ListWidget($input: ListWidgetInput!) {
    listWidget(input: $input) {
      _id
      widgetName
      widgetDescription
      createdAt
      updatedAt
      createdBy {
        sub
        name
      }
    }
  }
`;

export const CREATE_WIDGET = gql`
  mutation CreateWidget($input: CreateWidgetInput!) {
    createWidget(input: $input) {
      _id
      appId
      formId
      widgetName
      widgetDescription
      widgetType
      fontColor
      backgroundColor
      cardConfig {
        questionId
        operator
        allowAction
        actionType
        params {
          templateId
          formId
          link
          dashboardId
        }
        buttonLabel
      }
      createdAt
      updatedAt
      createdBy {
        sub
        name
      }
    }
  }
`;

export const DELETE_WIDGET = gql`
  mutation DeleteWidget($input: DeleteWidget!) {
    deleteWidget(input: $input) {
      _id
      widgetName
    }
  }
`;

export const UPDATE_WIDGET = gql`
  mutation UpdateWidget($input: UpdateWidgetInput!) {
    updateWidget(input: $input) {
      _id
      appId
      formId
      createdBy {
        sub
        name
      }
      widgetName
      widgetDescription
      widgetType
      fontColor
      backgroundColor
      cardConfig {
        questionId
        operator
        allowAction
        actionType
        params {
          templateId
          formId
          link
          dashboardId
        }
        buttonLabel
      }
      widgetFilter {
        logicalOperator
        fieldsets {
          questionId
          questionType
          relationalOperator
          secondaryRelationalOperator
          answer
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_WIDGET = gql`
  query GetWidget($input: GetWidgetInput!) {
    getWidget(input: $input) {
      _id
      appId
      formId
      widgetName
      widgetDescription
      widgetType
      fontColor
      backgroundColor
      cardConfig {
        questionId
        operator
        allowAction
        actionType
        params {
          templateId
          formId
          link
          dashboardId
        }
        buttonLabel
      }
      widgetFilter {
        logicalOperator
        fieldsets {
          questionId
          questionType
          relationalOperator
          secondaryRelationalOperator
          answer
        }
      }
    }
  }
`;
export const ADD_WIDGET_TO_DASHBOARD = gql`
  mutation AddWidgetToDashboard($input: AddWidgetContentToDashboardInput) {
    addWidgetToDashboard(input: $input) {
      _id
      dashboardName
      createdBy {
        sub
        name
      }
    }
  }
`;

export const LIST_DASHBOARD_CONTENT = gql`
  query ListDashboardContents($input: ListDashboardcontentsInput) {
    listDashboardContents(input: $input) {
      dashboardName
      widgets {
        _id
        widgetId
        dimensions {
          lg {
            i
            x
            y
            w
            h
            minW
            maxW
            minH
            maxH
          }
        }
      }
    }
  }
`;

export const GET_WIDGET_FOR_DASHBOARD = gql`
  query GetWidgetForDashboard($input: GetWidgetForDashboardInput!) {
    getWidgetForDashboard(input: $input) {
      _id
      widgetName
      aggregatorValue
      widgetDescription
      widgetType
      formId
      fontColor
      backgroundColor
      cardConfig {
        questionId
        operator
        actionType
        params {
          templateId
          formId
          link
          dashboardId
        }
        buttonLabel
      }
    }
  }
`;
export const DELETE_WIDGET_FROM_DASHBOARD = gql`
  mutation DeleteWidgetFromDashboard($input: DeleteWidgetFromDashboard) {
    deleteWidgetFromDashboard(input: $input) {
      _id
    }
  }
`;

export const GET_FORM_DATA_FOR_DASHBOARD_WIDGET = gql`
  query GetForm($input: GetFormInput!) {
    getForm(input: $input) {
      _id
      formName
    }
  }
`;

export const UPDATE_DASHBOARD_LAYOUT = gql`
  mutation UpdateDashboardLayout($input: UpdateDashboardLayout) {
    updateDashboardLayout(input: $input) {
      widgets {
        _id
        widgetId
      }
      dashboardName
    }
  }
`;

export const CLONE_WIDGET = gql`
  mutation CloneWidget($input: CloneWidgetInput!) {
    cloneWidget(input: $input) {
      _id
      widgetName
    }
  }
`;

export const CLONE_DASHBOARD = gql`
  mutation CloneDashboard($input: CloneDashboardInput!) {
    cloneDashboard(input: $input) {
      _id
      dashboardName
      createdAt
    }
  }
`;
